import { M365PulseTheme } from "Core/Theme/M365PulseTheme.types";
import { M365PulseWebDarkTheme } from "Core/Theme/M365PulseWebDarkTheme";
import { M365PulseWebLightTheme } from "Core/Theme/M365PulseWebLightTheme";
import { types } from "mobx-state-tree";

export const SiteThemeStore = types
    .model("siteTheme", {
        darkMode: types.maybe(types.boolean)
    })
    .volatile(() => ({
        systemPrefersDark: window.matchMedia("(prefers-color-scheme: dark)").matches
    }))
    .views((self) => ({
        get isDark(): boolean {
            if (self.darkMode === true) {
                return true;
            }
            if (self.darkMode === false) {
                return false;
            }
            return self.systemPrefersDark;
        },
        get currentFluentTheme(): M365PulseTheme {
            return this.isDark ? M365PulseWebDarkTheme : M365PulseWebLightTheme;
        },
        get themeLabel(): string {
            if (self.darkMode === true) {
                return "Dark";
            }
            if (self.darkMode === false) {
                return "Light";
            }
            return "System";
        }
    }))
    .actions((self) => ({
        setThemeMode(mode: boolean | undefined) {
            self.darkMode = mode;
        },
        setSystemPrefersDark(value: boolean) {
            self.systemPrefersDark = value;
        },
        toggleMode() {
            self.darkMode = !self.darkMode;
        }
    }));
